import React from 'react';
import Sidebar from '../learnSidebar';
import NavbarLearn from '../navbarLearn';
import useDocumentTitle from '../useDocumentTitle'

export default function Three() {
    useDocumentTitle("Chapter 3 | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">03</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">INTRO TO ONSHAPE</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">PLAN YOUR BOT WITHOUT BURNING MONEY</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">CHAPTER OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">Get to know the basics of Onshape</p>
                        <p class="font-productsans text-base text-black mt-5">This chapter will cover the basics of Onshape, a browser program that allows you to design 3D parts digitally. Check out the topics below:</p>
                        <a href="/learn/three">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 3</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">INTRODUCTION TO ONSHAPE</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/a">What is Onshape?</a>
                                    <p class="font-productsans font-normal ml-3">Understand what Onshape is and what it's used for.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/b">Setting up Onshape</a>
                                    <p class="font-productsans font-normal ml-3">Learn how to set up an Onshape account and get added to your team.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/c">Introduction to Sketching</a>
                                    <p class="font-productsans font-normal ml-3">Understand the concept of sketching within Onshape's Part Studio.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/d">Constraints</a>
                                    <p class="font-productsans font-normal ml-3">Learn how to constrain your sketches. Blue is bad.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/e">Introduction to Extrudes</a>
                                    <p class="font-productsans font-normal ml-3">Learn the basics of extruding a sketch into a 3D part.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/f">Introduction to the Assembly</a>
                                    <p class="font-productsans font-normal ml-3">Introduce yourself to Assembly. This might come as a surprise, but it's where you assemble stuff.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}